export default {
    namespaced: true,
    state: {
        stateList: ["AK", "AL", "AR", "AZ", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VT", "WA", "WI", "WV", "WY"],
        lenUnit: ["cm", "inch"],
        weightUnit: ["g", "lbs"],
        currency: ['USD', 'CNY', 'CAD', 'EUR', 'GPB', 'AUD', 'JPY'],
        countryList: ["US", "ES", "DE","JP"]
    },
    getters: {
        getStateList(state, getters) {
            return state.stateList;
        },
        getCountryList(state, getters) {
            return state.countryList;
        },
        getLenUnitList(state, getters) {
            return state.lenUnit;
        },
        getWeightUnitList(state, getters) {
            return state.weightUnit;
        },
        getCurrencyList(state, getters) {
            return state.currency;
        },
    },
    mutations: {
    },
    actions: {
    }
};
